// extracted by mini-css-extract-plugin
export default {"dropdown":"ConflictManager_dropdown__fzbH0"};